import React from 'react';
import './IconButton.css';
import { InfoCircleOutlined, CalendarOutlined, EditOutlined, SoundOutlined, SoundFilled } from '@ant-design/icons';
import type { IconButtonProps } from '../../types/components/icon-button';

export const IconButton: React.FC<IconButtonProps> = ({ onClick, type = 'info', className, icon }) => {
    let defaultIcon = <InfoCircleOutlined className="icon-button__icon" />;
    if (type === 'date') defaultIcon = <CalendarOutlined className="icon-button__icon" />;
    if (type === 'text') defaultIcon = <EditOutlined className="icon-button__icon" />;
    if (type === 'music-on') defaultIcon = <SoundFilled className="icon-button__icon" />;
    if (type === 'music-off') defaultIcon = <SoundOutlined className="icon-button__icon" />;

    return (
        <button className={`icon-button${className ? ' ' + className : ''}`} onClick={onClick} aria-label={type}>
            {icon || defaultIcon}
        </button>
    );
};
